/* global G */
import { API_URL } from 'lib/util/environment'

/**
 * Opens a route or an url in a new browser tab.
 *
 * @param {Gaia.Web.Application} app - web application reference
 * @returns {function(...[*])}
 */
const newTab = app => ({ url: routeOrUrl, params }) => {
  if (routeOrUrl[G.MODULE]) {
    const route = routeOrUrl
    const context = app[G.SESSION][G.STATE][G.CONTEXT]
    const moduleName = route[G.MODULE]
    const actionName = route[G.ACTION]
    const ref = route[G.REF]
    window.open(`#${context}/${moduleName}/${actionName}/${ref}`, '_blank')
  } else {
    const url = new URL(routeOrUrl, API_URL)
    url.search = params ? new URLSearchParams(params).toString() : url.search
    window.open(url.href, '_blank')
  }
}

export default newTab
